interface TableParams {
  id: string;
  active?: boolean;
  index?: number;
  description?: string;
  waiters?: string[];
  waiterCall?: boolean;
}

export class Table {
  id: string;
  active: boolean;
  index: number;
  description: string;
  waiters: string[];
  /** Кнопка вызова официанта включена у стола (приложение: настройка стола) */
  waiterCall: boolean;

  constructor(params: TableParams) {
    this.id = params.id;
    this.active = params.active ?? true;
    this.index = params.index ?? 0;
    this.description = params.description ?? '';
    this.waiters = params.waiters ?? [];
    this.waiterCall = params.waiterCall ?? false;
  }
}